export default __webpack_public_path__ + "static/media/1stCard.b64ff059.jpg";